import React from 'react';
import { Mutation } from '@apollo/client/react/components';

import UpdateBadgeVisibility from 'buyside/graphql/mutations/UpdateUserBadgeVisibility.graphql';

import BadgeDisplayOnProfileCheckbox from 'buyside/components/presentation/UserAccount/YourBadges/badgeDisplayOnProfileCheckbox';

const BadgeDisplayOnProfileCheckboxContainer = props => (
  <Mutation mutation={UpdateBadgeVisibility}>
    {mutate => {
      const updateBadgeVisibility = args => mutate({ variables: args });
      return (
        <BadgeDisplayOnProfileCheckbox updateBadgeVisibility={updateBadgeVisibility} {...props} />
      );
    }}
  </Mutation>
);

export default BadgeDisplayOnProfileCheckboxContainer;
